import { Routes } from '@angular/router';
import { environment } from './environments/environment';
import { RoutesEnum } from '@app/core/utils';
import { fetchProfileGuard } from '@app/core/authentication';

const _routes: Routes = [
    {
        path: RoutesEnum.NO_PERMISSIONS,
        loadComponent: () => import('./app/no-permissions/no-permissions.component').then((m) => m.NoPermissionsComponent),
        title: 'pages.noPermissions.tabTitle',
    },
    {
        path: '',
        canActivate: [fetchProfileGuard],
        loadChildren: () => import('@app/pages/pages-main').then((m) => m.PagesMainRoutes),
    },
    {
        path: 'dev',
        loadChildren: () => import('@app/pages/pages-dev').then((m) => m.PagesDevRoutes),
    },
];

if (environment.enableDevModule) {
    _routes.push({
        path: 'dev',
        loadChildren: () => import('@app/pages/pages-dev').then((m) => m.PagesDevRoutes),
    });
}

export const routes = _routes;
